let googleMapsPromise = null;

export const loadGoogleMaps = (apiKey) => {
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google);
  }

  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    // ✅ Check if script already exists in DOM (another component added it)
    const existing = document.querySelector(
      'script[src*="maps.googleapis.com"]'
    );
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google));
      return;
    }

    const script = document.createElement("script");

    // ✅ Add callback to avoid timing issues
    window.__googleMapsCallback = () => resolve(window.google);

    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=__googleMapsCallback`;
    script.async = true;
    script.defer = true;
    script.onerror = (e) => {
      googleMapsPromise = null; // ✅ Reset so retry is possible
      reject(e);
    };

    document.head.appendChild(script);
  });

  return googleMapsPromise;
};